// ==============================|| OVERRIDES - LINER PROGRESS ||============================== //

export default function LinearProgress(theme) {
	return {
		MuiLinearProgress: {
			styleOverrides: {}
		}
	}
}
